export default "__VITE_ASSET__Bgf4rB_l__"